module.exports = __webpack_public_path__ + "img/2.cc0426e5.png";